import { createSlice } from '@reduxjs/toolkit'

import * as API from 'api/ip_address/ip_address'
import type { AllowedIPAddressData, AllowedIPAddressEditData, AllowedIPAddressResponse } from 'api/ip_address/types'

import { handleApiError } from './utils'

import type { PayloadAction } from '@reduxjs/toolkit'
import type { AppThunk, RootState } from 'store'

type AllowedIPAddressState = {
  allowedIPAddress?: AllowedIPAddressData
  isRequesting: boolean
  errorMessage: string
}

const initialState: AllowedIPAddressState = {
  isRequesting: false,
  errorMessage: '',
  allowedIPAddress: undefined,
}

export const allowedIPAddressSlice = createSlice({
  name: 'allowedIPAddress',
  initialState,
  reducers: {
    startRequest: state => {
      state.isRequesting = true
      state.errorMessage = ''
    },
    apiFailure: (state, action: PayloadAction<{ errorMessage: string }>) => {
      state.isRequesting = false
      state.errorMessage = action.payload.errorMessage
    },
    getAllowedIPAddressSuccess: (state, action: PayloadAction<AllowedIPAddressResponse>) => {
      state.isRequesting = false
      state.allowedIPAddress = action.payload.allowedIPAddress
    },
    upsertAllowedIPAddressSuccess: state => {
      state.isRequesting = false
    },
  },
})

export const { startRequest, apiFailure, getAllowedIPAddressSuccess, upsertAllowedIPAddressSuccess } =
  allowedIPAddressSlice.actions

export const getAllowedIPAddress =
  (data: { workDate?: string; tenantId: number }): AppThunk =>
  async dispatch => {
    dispatch(startRequest())
    try {
      const res = await API.getAllowedIPAddress(data.tenantId, data.workDate)
      dispatch(getAllowedIPAddressSuccess(res))
    } catch (res) {
      handleApiError(res, dispatch, apiFailure)
    }
  }

export const upsertAllowedIPAddress =
  (data: AllowedIPAddressEditData, tenantId: number): AppThunk =>
  async dispatch => {
    dispatch(startRequest())
    try {
      await API.upsertAllowedIPAddress(data, tenantId)
      dispatch(upsertAllowedIPAddressSuccess())
      dispatch(getAllowedIPAddress({ tenantId }))
    } catch (res) {
      handleApiError(res, dispatch, apiFailure)
    }
  }

export const selectAllowedIPAddressStatus = (state: RootState) => ({ ...state.ipAddress })

export default allowedIPAddressSlice.reducer
